import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float-button"
      href={`https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
        "Hello JAYTRIKA, I have a telecom infrastructure requirement."
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with JAYTRIKA on WhatsApp"
      className="group fixed bottom-6 right-6 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-emerald-500/30 transition-all duration-300 hover:scale-110"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25" />
      <MessageCircle size={24} className="relative" />
    </a>
  );
}
